import { render } from "./DatasetTableOptionsCopyDetailsOptions.vue?vue&type=template&id=2bd28929"
import script from "./DatasetTableOptionsCopyDetailsOptions.vue?vue&type=script&lang=js"
export * from "./DatasetTableOptionsCopyDetailsOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__